import React from 'react'
import './Header.css'

const Header = () => {
  return (
    <div className = "Header">
      <span><h2 className='logo'>Text Editor</h2></span>
      <span><h5 className='github'><a href="https://https://github.com/shortlisted159.com/San-53" target="_blank">Github/Sanjukta-Singha</a></h5></span>
    </div>
  )
}

export default Header